<div id="company" *ngIf="company.name">
	{{ company.name }} {{ company.location.name && company.locationsCount && company.locationsCount > 1 ? '-' : '' }} <span style="font-size:18px;">{{ company.locationsCount && company.locationsCount > 1 ? company.location.name : '' }}</span>
</div>